
import EditCollection from 'layouts/collection/EditCollection.js';
import ManageCollections from 'layouts/collection/ManageCollections.js';
import AddCollection from 'layouts/collection/AddCollection.js';
import ProtectedRoute from "routes/protectedRoutes.js";
const CollectionRoutes = [


  {
    route: "productcollection/edit/:id/:type",
    key: "PoductcollectionEdit",
    component: <ProtectedRoute check="logout"><EditCollection  props={{'type':1}}/></ProtectedRoute>
  },
  {
    route: "servicecollection/edit/:id/:type",
    key: "PoductcollectionEdit",
    component: <ProtectedRoute check="logout"><EditCollection  props={{'type':1}}/></ProtectedRoute>
  },

  {
    route: "productcollection/list/:pid",
    key: "Collection-List-With-Parents",
    component: <ProtectedRoute check="logout"><ManageCollections  props={{'type':1}}/></ProtectedRoute>
  },
  {
    route: "servicecollection/list/:pid",
    key: "Collection-List-With-Parents",
    component: <ProtectedRoute check="logout"><ManageCollections  props={{'type':2}}/></ProtectedRoute>
  },
  {
    route: "productcollection/add",
    key: "Add-product-collection-With-Parents",
    component: <ProtectedRoute check="logout"><AddCollection props={{'type':1}}/></ProtectedRoute>
  },
  {
    route: "servicecollection/add",
    key: "Add-service-collection-With-Parents",
    component: <ProtectedRoute check="logout"><AddCollection props={{'type':2}}/></ProtectedRoute>
  }



  ];

export default CollectionRoutes;
 